export default __webpack_public_path__ + "static/media/round.77ec2db9.svg";